import NacimientoModal from "./NacimientoModal";
export default NacimientoModal;